var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.99995V5.89255",
    stroke: "#334266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.9691H5.9354",
    stroke: "#334266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7362 12.7075C9.24763 15.0921 9.5421 18.2672 11.6196 20.3401C14.0404 22.7555 17.9612 22.7555 20.382 20.3401M22.1976 15.9687C22.1976 14.3876 21.5924 12.8049 20.382 11.5972C18.3045 9.5243 15.1223 9.23051 12.7324 10.7157",
    stroke: "#334266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92988 24.0232C13.8862 26.9984 19.5344 26.69 23.1376 23.0931M22.4561 8.22337C18.4883 4.92187 12.5815 5.128 8.85785 8.84506C5.25291 12.4403 4.94383 18.076 7.92572 22.0234M26.0951 15.9691C26.0951 13.9937 25.5176 12.0183 24.3594 10.3189",
    stroke: "#334266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.0454V29.938",
    stroke: "#334266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9691L20.3809 20.3403L23.1399 23.0931L25.8989 25.846C28.6335 23.1191 30 19.5433 30 15.9691H26.0974H22.1964H16Z",
    fill: "#AECF6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6205 13.015C12.4046 13.015 13.0407 12.3803 13.0407 11.5978C13.0407 11.2651 12.9252 10.9583 12.7333 10.7164C12.473 10.3901 12.0711 10.1807 11.6205 10.1807C10.8363 10.1807 10.2002 10.8154 10.2002 11.5978C10.2002 12.0475 10.41 12.4484 10.7371 12.7082C10.9794 12.8997 11.2869 13.015 11.6205 13.015Z",
    fill: "#AECF6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4802 10.6224C23.8121 10.6224 24.118 10.5088 24.3588 10.3189C24.689 10.0591 24.9005 9.65658 24.9005 9.20372C24.9005 8.42126 24.2644 7.78655 23.4802 7.78655C23.0767 7.78655 22.714 7.95541 22.4553 8.22325C22.2112 8.47811 22.06 8.82381 22.06 9.20372C22.06 9.98771 22.6961 10.6224 23.4802 10.6224Z",
    fill: "#AECF6D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44017 23.093C7.44017 23.8754 8.0763 24.5101 8.86047 24.5101C9.28835 24.5101 9.6723 24.3218 9.93257 24.0231C10.149 23.7732 10.2807 23.4485 10.2807 23.093C10.2807 22.3106 9.64458 21.6759 8.86047 21.6759C8.50413 21.6759 8.17715 21.8074 7.92827 22.0233C7.6289 22.283 7.44017 22.6661 7.44017 23.093Z",
    fill: "#AECF6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.899 6.09231C20.4314 0.636859 11.5671 0.636859 6.1012 6.09231C0.633626 11.5461 0.633626 20.3907 6.1012 25.8461C11.5671 31.3015 20.4314 31.3015 25.899 25.8461C31.3665 20.3907 31.3665 11.5461 25.899 6.09231Z",
    stroke: "#334266",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools1);
export default __webpack_public_path__ + "static/media/tools1.a107479889b70569391727f4d43fceda.svg";
export { ForwardRef as ReactComponent };